import React, { useEffect } from 'react';

import { Box } from '@leagueplatform/genesis-core';
import { Chat } from '@leagueplatform/chat';
import { chatInstance } from 'common/chat-instance';
import { useDemoMode } from 'common/demo-mode';
import { useAutoSendInitialMessage } from 'common/use-auto-send-initial-message';
import { subscribeClearPendingInitialMessageOnSignOut } from 'common/clear-pending-initial-message-on-sign-out';
import { DemoPickerModal } from './demo-picker-modal.component';
import { DemoChat } from './demo-chat.component';

type ChatV2ContainerProps = {
  isPrivatePage: boolean;
};

// Chat provides its own ChatInstanceProvider, so mounting it here is enough —
// the /live-chat route reads the same singleton instance.
//
// A demo runs on its own surface next to it: the SDK's chat ships a corner panel
// with its own top bar and end-chat confirmation, and a demo wants a full-bleed
// surface with no way out but ending the session. Both are inert until something
// opens them, so mounting the pair costs nothing.
export const ChatV2Container: React.FC<ChatV2ContainerProps> = ({
  isPrivatePage,
}) => {
  // Keyed by run so each demo mounts a clean surface with its own instance.
  const { chatRunId } = useDemoMode();

  // Bound to the shared singleton, not the (possibly swapped) demo instance —
  // the live-chat entry page always starts a session on `chatInstance`.
  useAutoSendInitialMessage(chatInstance);

  useEffect(() => subscribeClearPendingInitialMessageOnSignOut(), []);

  if (!isPrivatePage) return null;

  return (
    <Box>
      <Chat chatInstance={chatInstance} />
      <DemoPickerModal />
      <DemoChat key={chatRunId} />
    </Box>
  );
};
